import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=789c9030&"
import script from "./ImageEditor.vue?vue&type=script&lang=ts&"
export * from "./ImageEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports